module.exports = "/assets/f1b1fd66f19f30e438b5c5c479e19a2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/TP.png
// module id = 2984
// module chunks = 0